import localForage from 'localforage';
import { extendPrototype as setItemsExtend } from 'localforage-setitems';
import { extendPrototype as startsWithExtend } from 'localforage-startswith';

setItemsExtend(localForage);
startsWithExtend(localForage);

export default {
    install (Vue, options) {
        Vue.prototype.$vlf = function(storeName) {
            return localForage.createInstance({
                name: process.env.VUE_APP_LF_DB,
                storeName: storeName
            });
        };
        Vue.prototype.$vlfClearDb = async function() {
            console.log('clearing anm22_food db');
            await localForage.dropInstance({
                name: process.env.VUE_APP_LF_DB
            });
        }
    }
}